import React, { useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Box from '@material-ui/core/Box';

import TicketsManagerTabs from "../../components/TicketsManagerTabs";
import Ticket from "../../components/Ticket";
import TicketAdvancedLayout from "../../components/TicketAdvancedLayout";

import { TicketsContext } from "../../context/Tickets/TicketsContext";

import { QueueSelectedProvider } from "../../context/QueuesSelected/QueuesSelectedContext";

const useStyles = makeStyles(theme => ({
    content: {
        overflow: "auto",
        flex: 1,
        minHeight: 0,
    },
}));

// Reescrito 2026-10-21 (pedido do usuario: layout mobile com cara de
// WhatsApp - abrir conversa em tela cheia ao tocar, voltar com uma seta,
// sem precisar trocar de aba na mao). Antes a tela mostrada era um
// estado "option" (0/1) separado, sincronizado via useEffect com a
// rota/currentTicket de um jeito que desalinhava facil (o "voltar" no
// cabecalho so mudava a URL, nao esse estado - ficava preso na
// conversa). Agora a tela mostrada vem direto da rota: tem ticketId na
// URL -> mostra a conversa; nao tem -> mostra a lista. Um unico dado
// manda, sem como desincronizar.
const TicketAdvanced = () => {
    const classes = useStyles();
    const { ticketId } = useParams();
    const { setCurrentTicket } = useContext(TicketsContext);

    useEffect(() => {
        return () => {
            setCurrentTicket({ id: null, uuid: null, code: null });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const showingTicket = Boolean(ticketId) && ticketId !== "undefined";

    return (
        <QueueSelectedProvider>
            <TicketAdvancedLayout>
                <Box className={classes.content}>
                    {showingTicket ? <Ticket /> : <TicketsManagerTabs />}
                </Box>
            </TicketAdvancedLayout>
        </QueueSelectedProvider>
    );
};

export default TicketAdvanced;
